import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/dashboard/metrics/guide/$slug")({
  head: () => ({
    meta: [{ title: "指标详解 · imiker CRM" }],
  })
});
